import { useUnit } from 'effector-react'
import { useNavigate, useParams } from 'react-router'

import EmptyIcon from '@/assets/images/not-found.svg'
import { Button } from '@/components/ui/button.tsx'
import { $creatorId } from '@/models/creators.ts'
import { CreateExpiringFansMessagesPage } from '@/modules/expiring-fans/components/create-expiring-fans-messages-page.tsx'
import { ExpiringFansPageSkeleton } from '@/modules/expiring-fans/components/expiring-fans-page-skeleton.tsx'
import { useGetExpiringFansMessageById } from '@/modules/expiring-fans/query/expiring-fans-query.ts'
import { AppRoutes } from '@/utils/constants.ts'

export const EditExpiringFansMessagePage = () => {
  const redirect = useNavigate()
  const { id } = useParams<{ id: string }>()
  const creatorId = useUnit($creatorId)

  const { data, isFetching } = useGetExpiringFansMessageById(id)

  const handleRedirect = () => {
    if (!creatorId) {
      return
    }
    redirect(AppRoutes.Creator.Settings.ExpiringFans.asUrl(creatorId))
  }

  if (isFetching) {
    return <ExpiringFansPageSkeleton />
  }

  if (!data) {
    return (
      <div className="mt-8 flex flex-col items-center justify-center gap-3 text-center">
        <EmptyIcon />
        <p>You do not have any data</p>
        <Button onClick={handleRedirect}>Go to Welcome Messages</Button>
      </div>
    )
  }

  return (
    <div className="w-full p-8">
      <CreateExpiringFansMessagesPage
        data={data}
        isEdit
      />
    </div>
  )
}
